import { useEffect, useState } from "react";
import styles from "./AlertFinish.module.css"
import { toast } from "react-toastify";
import { check } from "../../api/users.api";



function AlertFinish({ setIsOpen, entity, func }) {
    const [userData, setUserData] = useState({})
    const [descricao, setDescricao] = useState(" ")

    console.log(entity)

    useEffect(() => {
        check()
            .then(res => setUserData(res.data))
            .catch((error) => {
                if (error.response.status === 401) {
                    console.log("algo deu errado");
                }
            })
    }, [])


    return (
        <div className={styles.container}>
            <div className={styles.form}>
                <div className={styles.containerOne}>
                    <p>Os Ticket de ID {entity.id} será finalizado. Tem certeza que deseja prosseguir com essa ação?</p>
                </div>
                <div className={styles.containerDesc}>
                    <label>Menssagem: <span>*</span></label>
                    <textarea type="text" onChange={(e) => setDescricao(e.target.value)} required />
                </div>
                <div className={styles.containerButtons}>
                    <button className={styles.nao} onClick={() => setIsOpen(false)}>Não</button>
                    <button className={styles.sim} onClick={async () => {

                        const arrayDataPrevisao = entity.dataPrevisao.split("/");
                        const arrayDataAbertura = entity.dataPrevisao.split("/");
                        
                        let descricaoVerificada;

                        if(descricao != " ") {
                            descricaoVerificada = descricao
                        } else {
                            return toast.error("Obrigatório preencher o campo de menssagem");
                        }

                        const payload = {

                            Ticket: {
                                Id: entity.id,
                                Codigo: entity.codigo,
                                Status: "Finalizado",
                                PontoDeVerificacao: entity.pontoDeVerificacao,
                                QuantidadeOcorrencias: entity.quantidadeOcorrencias,
                                PrimeiraOcorrencia: null,
                                UltimaOcorrencia: null,
                                CarId: entity.car.id,
                                ChecklistId: entity.checklistId != 0 ? entity.checklistId : null,
                                Oficina: entity.oficina,
                                DataAbertura: `${arrayDataAbertura[2]}-${arrayDataAbertura[1]}-${arrayDataAbertura[0]}T00:00:00`,
                                DataPrevisao: `${arrayDataPrevisao[2]}-${arrayDataPrevisao[1]}-${arrayDataPrevisao[0]}T17:00:00`,
                                Custo: entity.custo,
                                Descricao: entity.descricao
                            },
                            Interaction: {
                                User: userData.name,
                                UserId: userData.id,
                                Message: descricaoVerificada,
                                TicketId: entity.id,
                                Status: "Finalizado"
                            }
                        }



                        await func(payload)
                            .then(() => {
                                setIsOpen(false);
                                toast.success(`Ticket ${entity.id} finalizado!`);
                            })
                            .catch((error) => {
                                if (error.response.status === 401) {
                                    return toast.error("Não autorizado!");
                                }
                            })
                    }}>
                        Sim
                    </button>
                </div>
            </div>
        </div>
    )
}

export default AlertFinish;